import React from 'react';

// cmp = array de ids · se construye leyendo el catálogo · orden = orden por deducible
export const Comparator = ({ ids, resolver, onFuente }) => {
  const items = ids.map((id) => resolver.byId[id]).filter(Boolean);
  return (
    <section className="cmp" data-testid="comparador">
      <div className="cmp-head">
        <span className="cmp-k">Comparador · ordenado por deducible</span>
        <span className="cmp-note">El asistente no recomienda: compara.</span>
      </div>
      <div className="cmp-grid">
        {items.map((p, pos) => {
          const coberturas = (p.coberturas_clave || '').split(';').slice(0, 3);
          const exclusiones = (p.exclusiones_principales || '').split(';').slice(0, 2);
          return (
            <article className="cmp-col" key={p.id} data-testid={`cmp-row-${p.id}`}>
              <span className="cmp-pos">{pos + 1}</span>
              <h3>{p.producto}</h3>
              <button
                type="button"
                className="cmp-figure"
                onClick={() => onFuente(`${p.id} · deducible`)}
                data-testid={`cmp-ded-${p.id}`}
              >
                <span className="cmp-label">Deducible</span>
                <span className="cmp-ded big">{resolver.ded(p.id)}</span>
              </button>
              <button
                type="button"
                className="cmp-figure"
                onClick={() => onFuente(`${p.id} · prima · ${p.prima_origen}`)}
                data-testid={`cmp-prima-${p.id}`}
              >
                <span className="cmp-label">Prima</span>
                <span className="cmp-prima">{resolver.prima(p.id)}</span>
                <span className={`cmp-origen ${resolver.origen(p.id) === 'tarifa publicada' ? 'pub' : 'ramo'}`}>
                  {resolver.origen(p.id) === 'tarifa publicada' ? 'Tarifa publicada' : 'Rango típico del mercado'}
                </span>
              </button>
              <div className="cmp-list">
                <span className="cmp-label">Coberturas clave</span>
                <ul>
                  {coberturas.map((c, i) => (
                    <li key={i}>{c.trim()}</li>
                  ))}
                </ul>
              </div>
              <div className="cmp-list">
                <span className="cmp-label">Exclusiones</span>
                <ul>
                  {exclusiones.map((c, i) => (
                    <li key={i}>{c.trim()}</li>
                  ))}
                </ul>
              </div>
              <button
                type="button"
                className="fuente-link"
                onClick={() => onFuente(`${p.id} · ${p.fuente || 'catálogo'}`)}
                data-testid={`cmp-fuente-${p.id}`}
              >
                Ver la fuente
              </button>
            </article>
          );
        })}
      </div>
    </section>
  );
};
